export default __webpack_public_path__ + "static/media/free.ca828e21.png";